var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile-card", on: { click: _vm.callback } },
    [
      _c("div", { staticClass: "profile-card__content" }, [
        _vm.title
          ? _c("span", { staticClass: "profile-card__title" }, [
              _vm._v(_vm._s(_vm.title)),
            ])
          : _vm._e(),
        _vm.subtitle
          ? _c("span", { staticClass: "profile-card__subtitle" }, [
              _vm._v(_vm._s(_vm.subtitle)),
            ])
          : _vm._e(),
        _vm.email
          ? _c("span", { staticClass: "profile-card__subtitle" }, [
              _vm._v(_vm._s(_vm.email)),
            ])
          : _vm._e(),
        _vm.phone
          ? _c("span", { staticClass: "profile-card__subtitle" }, [
              _vm._v(_vm._s(_vm.phone)),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "profile-card__circle" },
        [
          _vm.icon
            ? _c("IconComponent", { attrs: { name: _vm.icon } })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }